import Equipment, { EquipmentParams } from './equipment';
import Ship from './ship';

import drawLifeBar from '../../../utils/lifeBar';


export interface GeneratorParams extends EquipmentParams {
  energyMax?: number;
  energyPerSecond?: number;
}

export default class Generator extends Equipment implements GeneratorParams {
  energy: number;
  energyMax = 100;
  energyPerSecond = 10;

  constructor(params: GeneratorParams) {
    super(params);
    this.energy = this.energyMax;
  }

  equipTo(ship: Ship): Ship {
    super.equipTo(ship);
    this.ship.generator = this;
    return ship;
  }

  update(modifier: number): Generator {
    this.energy = Math.min(this.energy + this.energyPerSecond * modifier, this.energyMax);
    return this;
  }

  drawEnergyBar(): void {
    const barColor = { R: 150, G: 0, B: 255, A: 1 };
    const ratio = this.energy / this.energyMax

    drawLifeBar({
      x: this.ship.x - this.ship.width / 2,
      y: this.ship.y - this.ship.height / 2,
      width: this.ship.width,
      height: this.ship.width / 10,
      ratio,
      context: this.ship.context,
      startColor: barColor,
      endColor: barColor,
    });
  }
}